/**
 * User-facing permission descriptions (i18n).
 * Keys match permission slugs from `@alinea/types/PERMISSIONS`.
 */

export const permissionDescriptionsPtBr = {
  'gl:read':
    'Visualizar dados contábeis (contas, lançamentos, razão, saldos, livros, calendários, períodos, agrupamentos, contas gerenciais)',
  'gl:manage':
    'Gerenciar configuração contábil (livros, calendários, períodos, agrupamentos, contas gerenciais)',
  'gl:origin-link:read':
    'Visualizar o console de vínculos de origem: lançamentos importados, registros sem vínculo, candidatos sugeridos e a trilha de auditoria',
  'gl:origin-link:manage':
    'Vincular e desvincular lançamentos históricos importados a contas a pagar, pagamentos, faturas e movimentos de caixa (não altera dados contábeis)',
  'gl:account:create': 'Criar contas contábeis',
  'gl:account:update': 'Editar contas contábeis',
  'gl:closing:manage': 'Gerenciar processo de fechamento de período',
  'gl:closing:task:manage': 'Gerenciar tarefas customizadas do checklist de fechamento',
  'gl:fx-recovery:request': 'Criar uma prévia evidenciada de recuperação histórica de câmbio',
  'ap:onfly-auto-approval:manage':
    'Liberar ou revogar a aprovação automática de faturas de viagem OnFly',
  'ap:vendor-knowledge:manage':
    'Criar, versionar, desativar, dispensar e restaurar o conhecimento de fornecedores (regras de retenção, regras de crédito de PIS/COFINS e instruções)',
  'gl:fx-recovery:approve': 'Aprovar ou cancelar uma recuperação histórica de câmbio',
  'gl:fx-recovery:execute':
    'Executar uma recuperação histórica de câmbio aprovada e seus estornos contábeis',
  'gl:reversal:request': 'Solicitar estorno contábil (entra no fluxo de aprovação)',
  'gl:reversal:create': 'Executar estorno contábil diretamente (sem fluxo)',
  'gl:journal:draft': 'Criar, editar e cancelar rascunhos de lançamentos manuais',
  'gl:journal:post': 'Lançar rascunhos de lançamentos manuais no razão',
  'ap:expense-accrual:read':
    'Visualizar propostas e provisões de despesa (competência) e sugestões de baixa',
  'ap:expense-accrual:propose':
    'Criar, propor e dispensar provisões de despesa (competência) sem lançar no razão',
  'ap:expense-accrual:confirm':
    'Confirmar, baixar, manter ou estornar provisões de despesa e configurar a conta de passivo',
  'ap:bill:read': 'Visualizar contas a pagar e detalhes',
  'ap:bill:create': 'Criar contas a pagar (manual e importação)',
  'ap:bill:update': 'Editar contas a pagar em rascunho ou submetidas',
  'ap:bill:delete': 'Excluir ou anular contas a pagar',
  'ap:bill:submit': 'Submeter conta a pagar para aprovação',
  'ap:bill:reclassify': 'Alterar dimensões em contas aprovadas ou pagas',
  'ap:payment:read': 'Visualizar pagamentos',
  'ap:payment:create': 'Criar ou agendar pagamentos',
  'ap:payment:update': 'Editar detalhes de pagamento',
  'ap:payment:delete': 'Excluir ou cancelar pagamentos',
  'ap:payment:send': 'Despachar pagamentos para o banco',
  'ap:document:read': 'Visualizar caixa de documentos',
  'ap:received-nf:read': 'Visualizar notas fiscais recebidas',
  'ap:reimbursement:read': 'Visualizar solicitações de reembolso',
  'ap:reimbursement:all:read':
    'Visualizar todas as solicitações de reembolso no escopo do tenant e entidade',
  'ap:reimbursement:managed:read':
    'Visualizar reembolsos nos departamentos e centros de custo sob gestão do usuário',
  'ap:reimbursement:own:read': 'Visualizar reembolsos criados ou submetidos pelo próprio usuário',
  'ap:reimbursement:create': 'Criar solicitações de reembolso',
  'ap:reimbursement:manage': 'Gerenciar políticas de reembolso',
  'ap:contract-review:read':
    'Visualizar solicitações, alertas e configurações de revisão de contratos',
  'ap:contract-review:manage':
    'Criar e triar revisões de contratos, editar prompts/configurações e ações de recuperação',
  'ap:contract-review:legal-approve':
    'Aprovar ou rejeitar etapas jurídicas de revisão de contratos atribuídas ao usuário',
  'ap:contract-review:risk-approve':
    'Aprovar ou rejeitar etapas de risco/negócio atribuídas ao usuário',
  'ap:contract-review:approval-override':
    'Sobrescrever responsáveis por etapas de aprovação de contratos quando necessário',
  'ap:contract-review:settings-manage':
    'Gerenciar prompts, catálogo de agentes e configurações de revisão de contratos',
  'ap:purchase-request:read': 'Visualizar solicitações de compra e status de aprovação',
  'ap:purchase-request:create': 'Criar solicitações de compra',
  'ap:purchase-request:manage':
    'Gerenciar solicitações de compra, incluindo edição, cancelamento e anexos',
  'ap:purchase-request:update': 'Editar solicitações de compra em rascunho',
  'ap:purchase-request:submit': 'Submeter solicitações de compra para aprovação',
  'ap:purchase-request:approve': 'Aprovar solicitações de compra e converter em ordens de compra',
  'ap:purchase-request:reject': 'Rejeitar solicitações de compra em fluxo de aprovação',
  'ap:purchase-request:cancel': 'Cancelar solicitações de compra em rascunho ou aprovadas',
  'ap:purchase-order:read': 'Visualizar ordens de compra e sincronização de compromissos',
  'ap:purchase-order:create': 'Criar ordens de compra diretamente',
  'ap:purchase-order:manage': 'Atualizar ordens de compra e anexos',
  'ap:purchase-order:mark-ready': 'Marcar ordens de compra como prontas',
  'ap:purchase-order:fulfill': 'Marcar ordens de compra como atendidas',
  'ap:purchase-order:receive': 'Registrar recebimento de mercadorias/serviços',
  'ap:purchase-order:link-bill': 'Vincular contas a ordens de compra',
  'ap:purchase-request:convert': 'Converter requisições aprovadas em pedidos',
  'ap:purchase-order:cancel': 'Cancelar ordens de compra e compromissos associados',
  'budget:read': 'Visualizar orçamentos (lista e detalhe)',
  'budget:manage': 'Criar, duplicar, ativar, arquivar e editar orçamentos',
  'fpa:read': 'Visualizar rollups, templates, métricas e relatórios FP&A',
  'fpa:manage': 'Criar, editar e arquivar rollups, templates e métricas FP&A',
  'budget:line:read': 'Visualizar linhas, alertas e utilização de orçamento',
  'budget:line:manage': 'Criar, editar, arquivar e configurar linhas de orçamento',
  'budget:exception:read': 'Visualizar solicitações de exceção de orçamento pendentes',
  'ar:read':
    'Visualizar dados de contas a receber (faturas, recebimentos, pré-faturamento, serviços, grupos, modelos, clientes)',
  'ar:manage': 'Gerenciar todos os dados de contas a receber',
  'ar:create': 'Criar entidades de contas a receber (faturas, clientes, serviços, etc.)',
  'ar:approve': 'Aprovar faturas de contas a receber por emissão ou posting contábil',
  'ar:update': 'Editar entidades de contas a receber',
  'ar:delete': 'Excluir entidades de contas a receber',
  'ar:service:read':
    'Visualizar serviços de faturamento e serviços de custo, com detalhes e vínculos',
  'ar:service:create': 'Criar serviços de faturamento e serviços de custo',
  'ar:service:edit':
    'Editar serviços de faturamento e serviços de custo, incluindo ativar, desativar e vincular',
  'ar:service:manage': 'Gerenciar serviços de faturamento, incluindo exclusão',
  'ar:invoice:classify': 'Classificar faturas de contas a receber antes do posting contábil',
  'ar:invoice:reclassify': 'Reclassificar faturas de contas a receber já postadas',
  'ar:invoice:cancel-fiscal': 'Cancelar NFSe emitida e estornar lançamentos contábeis da fatura',
  'party:read': 'Visualizar fornecedores e clientes',
  'party:manage': 'Criar e editar fornecedores e clientes',
  'party:create': 'Criar fornecedores e clientes',
  'party:update': 'Editar fornecedores e clientes',
  'party:delete': 'Excluir fornecedores e clientes',
  'party:bank-info:approve': 'Aprovar alterações de dados bancários de fornecedores/clientes',
  'party:vendor-bank-account:manage':
    'Criar e editar contas bancárias de fornecedores (controle financeiro)',
  'hcm:read': 'Visualizar colaboradores e folha de pagamento',
  'hcm:manage': 'Gerenciar configuração e operações de RH',
  'hcm:payroll:create': 'Gerar ou importar folha de pagamento (rascunho para revisão)',
  'hcm:payroll:approve': 'Aprovar folha de pagamento (gera contas a pagar e lançamentos contábeis)',
  'op:read': 'Visualizar contas bancárias, cartões, investimentos e conciliação',
  'op:manage': 'Gerenciar tesouraria e conciliação',
  'reconciliation:close':
    'Fechar o extrato de uma conta bancária no mês, quando a prova de saldo estiver limpa',
  'reconciliation:reopen': 'Reabrir um extrato fechado, com justificativa registrada',
  'fga:manage': 'Gerenciar quem pode acessar recursos protegidos',
  'op:credit-card:all:read':
    'Visualizar todos os cartões e painéis de cartão no escopo do tenant e entidade',
  'op:credit-card:managed:read':
    'Visualizar cartões e painéis de cartão nos departamentos e centros de custo sob gestão do usuário',
  'org:read': 'Visualizar entidades, departamentos, centros de custo e segmentos',
  'org:manage': 'Gerenciar estrutura organizacional',
  'workflow:read': 'Visualizar fluxos e regras de aprovação',
  'workflow:manage': 'Gerenciar fluxos e regras de aprovação',
  'integration:read': 'Visualizar integrações e dimensões',
  'integration:manage': 'Gerenciar integrações e sincronização',
  'report:read': 'Visualizar relatórios (DRE, balanço, balancete, razão)',
  'report:cash-flow:manage': 'Gerenciar itens manuais da projeção de fluxo de caixa',
  'identity:user:read': 'Visualizar usuários',
  'identity:user:create': 'Criar ou convidar usuários',
  'identity:user:update': 'Editar usuários',
  'identity:user:delete': 'Remover usuários',
  'identity:role:read': 'Visualizar papéis',
  'identity:role:create': 'Criar papéis',
  'identity:role:update': 'Editar papéis e permissões',
  'identity:permission:read': 'Visualizar catálogo de permissões',
  'identity:tenant:read': 'Visualizar informações do tenant',
  'identity:audit-log:read': 'Visualizar trilha de auditoria',
  'settings:read': 'Visualizar configurações (geral, fiscal, temas, preferências)',
  'settings:manage': 'Gerenciar configurações',
  'fiscal:obligations:read':
    'Visualizar o catálogo de obrigações fiscais e as decisões de aplicabilidade de cada entidade',
  'fiscal:obligations:manage':
    'Decidir as obrigações fiscais, o tratamento de CBS/IBS e o perfil do estabelecimento de cada contribuinte e estabelecimento',
  'fiscal:obligations:evidence':
    'Avançar as ocorrências das obrigações fiscais e registrar evidência, pagamento e retificação',
  'dashboard:read': 'Visualizar painel',
} as const;

export const permissionDescriptionsEn = {
  'gl:read':
    'View all GL data (accounts, journals, ledger, balances, books, calendars, periods, rollups, managerial accounts)',
  'gl:manage': 'Manage GL configuration (books, calendars, periods, rollups, managerial accounts)',
  'gl:origin-link:read':
    'View the origin-linking console: imported journals, unlinked records, ranked candidates and the link audit trail',
  'gl:origin-link:manage':
    'Link and unlink historically-imported journals to bills, payments, invoices and cash movements (writes no GL data)',
  'gl:account:create': 'Create GL accounts',
  'gl:account:update': 'Edit GL accounts',
  'gl:closing:manage': 'Manage period closing process',
  'gl:closing:task:manage': 'Manage custom closing checklist tasks',
  'gl:fx-recovery:request': 'Create an evidenced historical FX recovery preview',
  'ap:onfly-auto-approval:manage': 'Enable or revoke automatic approval of OnFly travel bills',
  'ap:vendor-knowledge:manage':
    'Create, version, deactivate, dismiss and restore vendor knowledge (withholding rules, PIS/COFINS credit rules and instructions)',
  'gl:fx-recovery:approve': 'Approve or cancel a historical FX recovery',
  'gl:fx-recovery:execute': 'Execute an approved historical FX recovery and its journal reversals',
  'gl:reversal:request': 'Request a GL reversal (enters workflow)',
  'gl:reversal:create': 'Execute a GL reversal directly (no workflow)',
  'gl:journal:draft': 'Create, update, and cancel draft manual journal entries',
  'gl:journal:post': 'Post draft manual journal entries to the ledger',
  'ap:expense-accrual:read':
    'View expense accrual proposals, posted accruals, and settlement suggestions',
  'ap:expense-accrual:propose':
    'Create, propose, and dismiss expense accruals without posting to the ledger',
  'ap:expense-accrual:confirm':
    'Confirm, settle, keep, or reverse expense accruals, and configure the liability account',
  'ap:bill:read': 'View AP bills and details',
  'ap:bill:create': 'Create AP bills (manual + import)',
  'ap:bill:update': 'Edit AP bills in DRAFT/SUBMITTED state',
  'ap:bill:delete': 'Delete/void AP bills',
  'ap:bill:submit': 'Submit AP bill for approval',
  'ap:bill:reclassify': 'Change dimensions on APPROVED/PAID bills',
  'ap:payment:read': 'View AP payments',
  'ap:payment:create': 'Create/schedule AP payments',
  'ap:payment:update': 'Edit payment details',
  'ap:payment:delete': 'Delete/cancel payments',
  'ap:payment:send': 'Dispatch payments to bank',
  'ap:document:read': 'View document inbox',
  'ap:received-nf:read': 'View received NFs',
  'ap:reimbursement:read': 'View reimbursement requests',
  'ap:reimbursement:all:read': 'View all reimbursement requests within tenant and entity scope',
  'ap:reimbursement:managed:read':
    'View reimbursement requests in departments and cost centers managed by the user',
  'ap:reimbursement:own:read': 'View reimbursement requests created or submitted by the user',
  'ap:reimbursement:create': 'Create reimbursement requests',
  'ap:reimbursement:manage': 'Manage reimbursement policies',
  'ap:contract-review:read': 'View procurement contract review requests, flags, and settings',
  'ap:contract-review:manage':
    'Create and triage contract reviews, edit prompts/settings, and run admin recovery actions',
  'ap:contract-review:legal-approve':
    'Approve or reject legal contract review stages assigned to the user',
  'ap:contract-review:risk-approve': 'Approve or reject business risk stages assigned to the user',
  'ap:contract-review:approval-override':
    'Override contract review approval stage assignees when needed',
  'ap:contract-review:settings-manage':
    'Manage contract review prompts, agent catalog, and module settings',
  'ap:purchase-request:read': 'View purchase requests and approval status',
  'ap:purchase-request:create': 'Create purchase requests',
  'ap:purchase-request:manage':
    'Manage purchase requests, including edits, cancellation, and document attachments',
  'ap:purchase-request:update': 'Edit draft purchase requests',
  'ap:purchase-request:submit': 'Submit purchase requests for approval',
  'ap:purchase-request:approve': 'Approve purchase requests and convert them to purchase orders',
  'ap:purchase-request:reject': 'Reject purchase requests in approval workflow',
  'ap:purchase-request:cancel': 'Cancel draft or approved purchase requests',
  'ap:purchase-order:read': 'View purchase orders and commitment sync status',
  'ap:purchase-order:create': 'Create purchase orders directly',
  'ap:purchase-order:manage': 'Update purchase orders and supporting documents',
  'ap:purchase-order:mark-ready': 'Mark purchase orders ready',
  'ap:purchase-order:fulfill': 'Mark purchase orders fulfilled',
  'ap:purchase-order:receive': 'Record goods or services receipt',
  'ap:purchase-order:link-bill': 'Link AP bills to purchase orders',
  'ap:purchase-request:convert': 'Convert approved purchase requests to orders',
  'ap:purchase-order:cancel': 'Cancel purchase orders and associated commitments',
  'budget:read': 'View budget plans (list and detail)',
  'budget:manage': 'Create, duplicate, activate, archive, and edit budget plans',
  'fpa:read': 'View FP&A rollups, templates, metrics, and evaluated reports',
  'fpa:manage': 'Create, edit, and archive FP&A rollups, templates, and metrics',
  'budget:line:read': 'View budget lines, alerts, and utilization',
  'budget:line:manage': 'Create, edit, archive, and configure budget lines',
  'budget:exception:read': 'View pending budget exception requests',
  'ar:read':
    'View all AR data (invoices, receipts, pre-billing, services, groups, templates, customers)',
  'ar:manage': 'Manage all AR data',
  'ar:create': 'Create AR entities (invoices, customers, services, etc.)',
  'ar:approve': 'Approve AR invoices by issuing them or posting them to GL',
  'ar:update': 'Edit AR entities',
  'ar:delete': 'Delete AR entities',
  'ar:service:read': 'View billing services and cost services, with their details and links',
  'ar:service:create': 'Create billing services and cost services',
  'ar:service:edit':
    'Edit billing services and cost services, including activating, deactivating and linking them',
  'ar:service:manage': 'Manage billing service catalog items, including deletion',
  'ar:invoice:classify': 'Classify AR invoices before GL posting',
  'ar:invoice:reclassify': 'Reclassify posted AR invoices',
  'ar:invoice:cancel-fiscal': 'Cancel emitted NFSe and reverse AR invoice GL postings',
  'party:read': 'View vendors and customers',
  'party:manage': 'Create/edit vendors and customers',
  'party:create': 'Create vendors and customers',
  'party:update': 'Edit vendors and customers',
  'party:delete': 'Delete vendors and customers',
  'party:bank-info:approve': 'Approve vendor/customer bank information changes',
  'party:vendor-bank-account:manage': 'Create/edit vendor bank accounts (financial control)',
  'hcm:read': 'View employees and payroll',
  'hcm:manage': 'Manage HCM configuration and operations',
  'hcm:payroll:create': 'Generate/import payroll (creates draft for review)',
  'hcm:payroll:approve': 'Approve payroll (generates AP bills + GL postings)',
  'op:read': 'View bank accounts, cards, investments, reconciliation',
  'op:manage': 'Manage treasury and reconciliation',
  'reconciliation:close':
    'Close a bank account statement for a month once the balance proof is clean',
  'reconciliation:reopen': 'Reopen a closed bank account statement with a recorded justification',
  'fga:manage': 'Manage who can access protected resources',
  'op:credit-card:all:read':
    'View all credit cards and card dashboards within tenant and entity scope',
  'op:credit-card:managed:read':
    'View credit cards and card dashboards in departments and cost centers managed by the user',
  'org:read': 'View entities, departments, cost centers, segments',
  'org:manage': 'Manage organizational structure',
  'workflow:read': 'View approval flows and rules',
  'workflow:manage': 'Manage approval flows and rules',
  'integration:read': 'View integrations and dimensions',
  'integration:manage': 'Manage integrations and sync',
  'report:read': 'View all reports (P&L, Balance Sheet, Trial Balance, Ledger)',
  'report:cash-flow:manage': 'Manage manual cash-flow forecast items',
  'identity:user:read': 'View users',
  'identity:user:create': 'Create/invite users',
  'identity:user:update': 'Edit users',
  'identity:user:delete': 'Remove users',
  'identity:role:read': 'View roles',
  'identity:role:create': 'Create roles',
  'identity:role:update': 'Edit roles and permissions',
  'identity:permission:read': 'View permission registry',
  'identity:tenant:read': 'View tenant info',
  'identity:audit-log:read': 'View audit trail',
  'settings:read': 'View all settings (general, fiscal, themes, preferences)',
  'settings:manage': 'Manage all settings',
  'fiscal:obligations:read':
    'View the fiscal obligations catalog and each entity applicability decisions',
  'fiscal:obligations:manage':
    'Decide the fiscal obligations, CBS/IBS treatment and establishment profile of each Taxpayer and establishment',
  'fiscal:obligations:evidence':
    'Move fiscal obligation occurrences forward and record evidence, payment and rectification',
  'dashboard:read': 'View dashboard',
} as const;
